export var Language;
(function (Language) {
    Language["ENGLISH"] = "en-us";
    Language["FRENCH"] = "fr-ca";
})(Language || (Language = {}));
